export default __webpack_public_path__ + "static/icon-27-5-00784d2f810544336be2135f99005e74.png";